import SC from "./style";
import { useEffect, useState } from "react";
import { Button, Label } from "InnoUI/components";
import theme from "theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { apiPost } from "api/callApi";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { regexTypes, validateEmail, validtionMessages } from "utils/config";
import { genderOption, nameTitle, sendCedential } from "utils/optionData/utils";
import { CompanyDropdown, CountryCodeDropdown, InputField } from "components";
import { useSelector } from "react-redux";
import RoleDropdown from "components/RoleDropdown";
import { useNavigate, useSearchParams } from "react-router-dom";
import { showAlert } from "utils/helper";

const AddAdditionalContact = (props) => {
  const {
    openModalView,
    setPropData = () => {},
    createTO = false,
    onClose = () => {},
  } = props;
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const navigate = useNavigate();

  const [data, setData] = useState({
    gender: "2",
    title: "0",
    telCode: "+27",
    cellCode: "+27",
    // faxCode: "+27",
    sendEmail: 1,
    adminStatus: false,
    isGoogleSignIn: false,
  });
  const [errorKeys, setErrorKeys] = useState({
    userName: false,
    email: false,
    secondaryEmail: false,
  });

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );
  const currentOccupant = useSelector(
    (state) => state?.currentOccupant?.data || []
  );

  const sendNotificationTo = [
    { id: 1, label: "To", key: "sendTo" },
    { id: 2, label: "Cc", key: "sendCc" },
    { id: 3, label: "Bcc", key: "sendBcc" },
  ];

  const handleChange = (property, value) => {
    // Validate email fields
    if (property === "email" || property === "secondaryEmail") {
      if (!validateEmail(value)) {
        setErrorKeys((prevKeys) => ({ ...prevKeys, [property]: true }));
      } else {
        setErrorKeys((prevKeys) => ({ ...prevKeys, [property]: false }));
      }
    }

    // Update form data state
    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      ...data,
      userName: data.email.toLowerCase(),
      email: data.email.toLowerCase(),
      secondaryEmail: data.secondaryEmail
        ? data.secondaryEmail.toLowerCase()
        : "",
    };

    if (!data.role) {
      showAlert({
        title: "Warning",
        text: "Role is required",
        icon: "warning",
      });
      return;
    }

    if (!validateEmail(data.email)) {
      setErrorKeys((prevKeys) => ({ ...prevKeys, email: true }));
      return;
    }
    if (data.secondaryEmail && !validateEmail(data.secondaryEmail)) {
      setErrorKeys((prevKeys) => ({ ...prevKeys, secondaryEmail: true }));
      return;
    }
    setErrorKeys({
      email: false,
      secondaryEmail: false,
    });
    setLoading(true);
    try {
      const endpoint = `/v1/adduser`;
      const response = await apiPost(endpoint, formData);
      const userData = response.data;

      // Assign user if response contains user data
      if (userData) {
        await assignUserToProject(userData);
        if (createTO) {
          navigate(0);
        }
      }
      setData({ gender: "2", telCode: "+27", cellCode: "+27" });
    } catch (error) {
      if (error?.response?.status == 409 && createTO) {
        const existingUserData = error.response?.data?.data;
        try {
          // const confirmAssign = await showAlert({
          //   title: error.response?.data?.message,
          //   text: `This ${
          //     existingUserData?.fullName
          //   } already exists. Do you want to assign them to this ${
          //     type == 0
          //       ? currentProject?.propertyName
          //       : currentOccupant?.occupantName
          //   }?`,
          //   icon: "warning",
          //   buttons: ["Cancel", "OK"],
          //   dangerMode: true,
          // });

          await assignUserToProject(existingUserData);
          if (createTO) {
            navigate(0);
          }
        } catch (assignError) {
          console.error("assignUserToProject error:", assignError);
          await showAlert({
            title: "Assign Failed",
            text:
              assignError.response?.data?.message || "Could not assign user",
            icon: "error",
          });
        }
      } else {
        console.error("Add user failed:", error);
        await showAlert({
          title: "Failed",
          text: error?.response?.data?.message || "An error occurred",
          icon: "error",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const assignUserToProject = async (userData) => {
    const result = await apiPost(`/v1/occupant/contactinformation`, {
      userId: [userData.id],
      projectId: currentProject.id,
      occupantId: type == 1 ? currentOccupant.id : null,
      roleId: data.role,
    });

    setPropData((prevData) => {
      const fieldKey =
        sendNotificationTo.find((item) => item.id == data?.sendEmail)?.key ||
        "sendTo";
      return {
        ...prevData,
        [fieldKey]: prevData[fieldKey]
          ? `${prevData[fieldKey]}, ${userData?.email}`
          : userData?.email,
      };
    });

    showAlert({
      title: "Success",
      text: result?.message,
      icon: "success",
    });

    onClose();
  };

  const AddModalData = () => {
    return (
      <SC.Form onSubmit={handleSubmit}>
        <SC.FormWrapper>
          {!createTO && (
            <Label label={"Create to"}>
              <RadioGroup
                row
                name="sendEmail"
                value={data?.sendEmail || ""}
                onChange={(e) => handleChange("sendEmail", e.target.value)}
              >
                {sendNotificationTo.map((option) => (
                  <FormControlLabel
                    key={option.id}
                    value={option.id}
                    control={
                      <Radio
                        sx={{
                          "& .MuiSvgIcon-root": {
                            fontSize: 16,
                          },
                          "&.Mui-checked": {
                            color: "#EC810B",
                          },
                          margin: "0px 0px 0px 10px",
                        }}
                      />
                    }
                    label={option.label}
                  />
                ))}
              </RadioGroup>
            </Label>
          )}
          <SC.LabelContainer>
            <SC.Label>
              Full Name <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <SC.Select
                  name="title"
                  value={data.title}
                  onChange={(e) => handleChange("title", e.target.value)}
                  style={{
                    height: "29px",
                    marginRight: "5px",
                    fontSize: "11px",
                  }}
                >
                  {nameTitle.map((title) => (
                    <option key={title.id} value={title.id}>
                      {title.label}
                    </option>
                  ))}
                </SC.Select>

                <InputField
                  name="fullName"
                  value={data.fullName}
                  onChange={handleChange}
                  style={{ width: "82%", height: "29px" }}
                  required
                  regexType={regexTypes.textOnly}
                  // capitalize={true}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>

          {/* Email Inputs */}
          <SC.LabelContainer>
            <SC.Label>
              Email (Default) <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <InputField
                name="email"
                value={data.email}
                onChange={handleChange}
                required
                type="email"
                style={{ width: "100%" }}
              />

              {errorKeys.email && (
                <SC.ValidtionMessages>
                  {validtionMessages.email}
                </SC.ValidtionMessages>
              )}
            </SC.Children>
          </SC.LabelContainer>

          <Label label="Email (Secondary)">
            <InputField
              name="secondaryEmail"
              value={data.secondaryEmail}
              onChange={handleChange}
              type="email"
              style={{ width: "100%" }}
            />

            {errorKeys.secondaryEmail && (
              <SC.ValidtionMessages>
                {validtionMessages.email}
              </SC.ValidtionMessages>
            )}
          </Label>

          {/* Cell Input */}

          <SC.LabelContainer>
            <SC.Label>
              Cell <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <SC.Wrapper style={{ display: "flex", gap: "10px" }}>
                <CountryCodeDropdown
                  name="cellCode"
                  defaultValue={data.cellCode}
                  onChange={handleChange}
                />

                <InputField
                  name="cell"
                  value={data.cell}
                  onChange={handleChange}
                  required
                  type="number"
                  style={{ width: "85.5%", height: "29px" }}
                  maxLength={15}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>

          <Label label="Tel (Secondary)">
            <SC.Wrapper style={{ gap: "10px" }}>
              <CountryCodeDropdown
                name="telCode"
                defaultValue={data.telCode}
                onChange={handleChange}
              />

              <InputField
                name="tel"
                value={data.tel}
                onChange={handleChange}
                type="number"
                style={{ width: "85.5%", height: "29px" }}
                maxLength={15}
              />
            </SC.Wrapper>
          </Label>

          {/* Company Name */}
          <Label label="Company Name">
            <CompanyDropdown
              name="companyId"
              onChange={handleChange}
              defaultValue={data?.companyId || undefined}
              newItemLabel={"+ New Company"}
              setSelectedCompany={(value) => {
                handleChange("companyId", value);
              }}
              width="100%"
              //   disabledDropdown={companyId}
            />
          </Label>

          {/* Send Credentials Option */}

          {/* Username Input */}
          <SC.LabelContainer>
            <SC.Label>
              Username <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <InputField
                name="userName"
                //value={data.userName}
                value={data.email}
                onChange={handleChange}
                required
                disabled={true}
                style={{ width: "100%" }}
              />

              {errorKeys.userName && (
                <SC.ValidtionMessages>
                  {validtionMessages.username}
                </SC.ValidtionMessages>
              )}
            </SC.Children>
          </SC.LabelContainer>
          <SC.LabelContainer>
            <SC.Label>
              Select Role <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <RoleDropdown
                name="role"
                onChange={handleChange}
                defaultValue={data.role}
                width={"100%"}
              />
            </SC.Children>
          </SC.LabelContainer>

          {/* Admin Status Switch */}
          {/* <Label label="Admin Status">
            <Switch
              checked={data.adminStatus}
              onChange={(e) => handleChange("adminStatus", e.target.checked)}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Label>
          <Label label="Google Login">
            <Switch
              checked={data.isGoogleSignIn}
              onChange={(e) => handleChange("isGoogleSignIn", e.target.checked)}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Label> */}

          {/* Buttons */}
          <SC.ButtonContainer>
            <Button
              caption="Cancel"
              onClick={onClose}
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
            />
            <Button
              caption={loading ? "Creating..." : "Create"}
              type="submit"
              isLoading={loading}
              color="white"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
            />
          </SC.ButtonContainer>
        </SC.FormWrapper>
      </SC.Form>
    );
  };

  return (
    <>
      {openModalView && (
        <BulkActionView
          title={createTO ? "New User" : "Create New Contact"}
          openModal={openModalView}
          renderBodyConditionally={AddModalData}
          handleCloseModal={() => {
            onClose();
            setData("");
          }}
        />
      )}
    </>
  );
};

export default AddAdditionalContact;
